function areRangesOverlapping (range1, range2) {
    let beginOfFirst = getBegin(range1)
    let endOfFirst = getEnd(range1)
    let beginOfSecond = getBegin(range2)
    let endOfSecond = getEnd(range2)

    return !(endOfFirst < beginOfSecond || endOfSecond < beginOfFirst)
}

function areRangesNextToEachOther (range1, range2) {
    let beginOfFirst = getBegin(range1)
    let endOfFirst = getEnd(range1)
    let beginOfSecond = getBegin(range2)
    let endOfSecond = getEnd(range2)

    return beginOfFirst === endOfSecond + 1 || beginOfSecond === endOfFirst + 1
}

function unifyRanges (currentPoolOfRanges, newOnes) {
    let connected = [...currentPoolOfRanges, ...newOnes]
    connected.sort((a1, a2) => getBegin(a1) - getBegin(a2))
    let hasChanged = true
    let safetyBreak = connected.length * connected.length // to break infinite loop
    let j = 0
    while (hasChanged) {
        if (connected.length === 1) {
            break
        }
        hasChanged = false
        for (let i = 0; i < connected.length - 1; i++) {
            let current = connected[i]
            let next = connected[i + 1]

            if (areRangesOverlapping(current, next) || areRangesNextToEachOther(current, next)) {
                let begin = Math.min(getBegin(current), getBegin(next))
                let end = Math.max(getEnd(current), getEnd(next))
                connected.splice(i, 2, [begin, end])
                hasChanged = true
                break
            }
        }
        if (j++ > safetyBreak) {
            break
        }
    }

    return connected
}

function getOverlappingLength (ranges, rangeToCheckOverlap) {
    return ranges.reduce((sum, range) => {
        if (areRangesOverlapping(range, rangeToCheckOverlap)) {
            let maximumStart = Math.max(getBegin(range), getBegin(rangeToCheckOverlap))
            let minimumEnd = Math.min(getEnd(range), getEnd(rangeToCheckOverlap))
            return sum + minimumEnd - maximumStart
        }
        return sum
    }, 0)
}

function sumRanges (ranges) {
    return ranges.reduce((sum, range) => {
        return sum + getEnd(range) - getBegin(range)
    }, 0)
}

function getBegin (range) {
    return Math.round(range[0])
}

function getEnd (range) {
    return Math.round(range[1])
}

export default {
    unifyRanges,
    sumRanges,
    areRangesOverlapping,
    areRangesNextToEachOther,
    getOverlappingLength
}
